import { isBrowser } from 'react-device-detect';

const browserOverride = link => {
  const browserLink = '/contact-management';
  return isBrowser ? `${browserLink}${link}` : link;
};

export default browserOverride;
